export { default } from './footer-privacy-policy';
